import { AlertIcon } from "@icons";
import styles from "./OfflineBanner.module.css";

export function OfflineBanner() {
  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <AlertIcon width={16} height={16} />
      <span className={styles.text}>You're offline — some features unavailable.</span>
    </div>
  );
}